import { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MachineDetali from './components/MachineDetali';
import TabsProvider from './components/TabsProvider';
import { useTranslation } from 'react-i18next';
import OInput from '../../../../UI/FormControls/OInput';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import useHttp from '../../../../../hooks/use-http';

const DetailView = ({ machineDetail, setMachineDetail }) => {
  const [expandedDetalis, setExpandedDetalis] = useState(true);
  const { t, i18n } = useTranslation();
  const [internaOznaka, setInternaOznaka] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const { getData } = useHttp('');

  const handleChangeSastavnice = () => {
    setExpandedDetalis(!expandedDetalis);
  };

  useEffect(() => {
    if (
      machineDetail?.oznakaKupac !== '' &&
      machineDetail?.oznakaKupac !== null &&
      machineDetail?.oznakaKupac !== undefined
    ) {
      setInternaOznaka(machineDetail?.oznakaKupac);
    } else {
      setInternaOznaka(machineDetail.sifra);
    }
  }, []);

  const handleChangeInterna = (e) => {
    setInternaOznaka(e.target.value);
  };
  const getMasina = async (idMasine = machineDetail.idMasine) => {
    console.log(idMasine);
    const config = {
      method: 'POST',
      url: 'Masine/vrati_masinu_za_id',
      data: { id: idMasine, metadata: i18n.language },
    };
    console.log('Config za masinu', config);
    const resposne = await getData(config);
    console.log('MASINA ZA ID', resposne);
    if (resposne) {
      setMachineDetail(resposne);
      setInternaOznaka(resposne.oznakaKupac);
    }
  };
  const handleSave = async () => {
    const config = {
      url: 'Masine/izmena_oznaka_kupca',
      method: 'POST',
      data: { id: machineDetail.id, oznaka: internaOznaka },
    };
    const response = await getData(config);
    if (response.opis === 'uspesno') {
      console.log(machineDetail);
      getMasina(machineDetail.id);
      setOpenDialog(false);
    }
  };
  return (
    <div>
      <Accordion expanded={expandedDetalis} onChange={handleChangeSastavnice}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <strong>
            {machineDetail.tipMasine === 'Robot'
              ? t('robotDetail')
              : t('moldDetail')}
          </strong>
        </AccordionSummary>
        <AccordionDetails>
          <MachineDetali
            handleOpenDialog={() => setOpenDialog(true)}
            machine={machineDetail}
          />
        </AccordionDetails>
      </Accordion>
      <TabsProvider machine={machineDetail} />

      <MuiDialog
        maxWidth="sm"
        open={openDialog}
        title={t('titles.changeInternalTagTitle')}
        content={
          <OInput
            label={`${t('internalcode')} ${
              machineDetail.tipMasine === 'Robot' ? t('robota') : t('alata')
            }`}
            name="internaOznaka"
            value={internaOznaka}
            handleChange={handleChangeInterna}
            style={{ width: '100%', marginTop: '15px' }}
          />
        }
        handleClose={() => setOpenDialog(false)}
        handleConfirm={handleSave}
        deniedText={t('close')}
      />
    </div>
  );
};

export default DetailView;
